module.exports = __webpack_public_path__ + "img/e09da57.jpg";